import React from 'react';

export const SCOPE_LABELS = {
	SECTION_TITLE: 'Scope',
	ADD_DOMAIN_RULE: 'Add Domain Rule',
	ADD_DOMAIN: 'Add Domain',
	ADD_LANGUAGE: 'Add language',
	ADD_REGEX_RULE: 'Add Regex rule',
	INCLUDE_REGEX: 'Include Regex',
	EXCLUDE_REGEX: 'Exclude Regex',
	INCLUDE_LANGUAGE: 'Include Language',
	EXCLUDE_LANGUAGE: 'Exclude Language',
	INCLUDE_DOMAIN: 'Include Domain',
	EXCLUDE_DOMAIN: 'Exclude Domain',
	ARIA_DOMAIN: 'Domain',
	ARIA_URL_REGEX: 'URL Regex',
	ARIA_LANGUAGE: 'Language',
	URL_PLACEHOLDER: 'e.g. ^https?://.*.example.com(/.*)?$',
	LANG_PLACEHOLDER: 'e.g. en-US',
	SELECT_PLACEHOLDER: 'Select Regex type',
	SELECT_LABEL: 'Regex type',
	DELETE_RULE_TITLE: 'Delete rule',
	DELETE_BUTTON: 'Delete',
	DELETE_CONFIRM_MESSAGE: 'Are you sure you want to delete this rule?'
} as const;

export const SCOPE_MORE_INFO = (
	<>
		As Evinced crawls properties, it can get to other internal properties as well as external sites
		(e.g. Twitter, LinkedIn etc.). <br />
		URL rules are applied on URLs and domains while Language rules operate on the HTML language tag.
		<br />
		Use regular expressions (Regex) rules to control the crawler.
		<br />
		<br />
		<b>Include:</b> A Regex to define the domains, subdomains, URLs or languages to be included in
		the scope of the property. By default, at least one Include URL Regex must exist. <br />
		<br />
		<b>Exclude:</b> Enables you to exclude domains, subdomains, URLs or languages from the above
		property scope.
	</>
);
